import { render, staticRenderFns } from "./DocumentDetailList3.vue?vue&type=template&id=54d19083&scoped=true"
import script from "./DocumentDetailList3.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d19083",
  null
  
)

export default component.exports